import React, { useRef } from "react";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { Editor } from "primereact/editor";
import { Toast } from 'primereact/toast';

import "./styles.css";

const InicioConfiguracao = ({ questionario, setQuestionario, setFluxoGerenciamento }) => {

    //hooks react

    const setTituloChange = (value) => {
        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            titulo: value,
        }));
    };

    const setTextoInicialChange = (value) => {
        setQuestionario((prevQuestionario) => ({
            ...prevQuestionario,
            textoInicial: value,
        }));
    };

    const toast = useRef(null);

     // Função para exibir um aviso de erro
     const showErrorToast = (message) => {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: message });
    };

    //renderização dos componentes da pagina
    return (
        <div className="questionario-etapa-prepos" style={{marginTop: '0px'}}>
            <Card title="Início do Questionario">
                <p className="m-0">
                    <div className="dados-iniciais">
                        <div className="titulo" style={{marginBottom: '0px'}}>
                            <label className="atributo">Título*</label>
                            <InputText id="input" value={questionario.titulo} onChange={(e) => setTituloChange(e.target.value)} />
                        </div>
                        <div className="textoInicial">
                        <label className="atributo">Texto Inicial</label>
                            <Editor
                                id="input-area"
                                onTextChange={(e) => setTextoInicialChange(e.htmlValue)}
                                className="editor-inicial"
                                onLoad={(quill) => {
                                    if (questionario.textoInicial) {
                                        quill.clipboard.dangerouslyPasteHTML(0, questionario.textoInicial, 'silent');
                                    }
                                }}
                            />
                        </div>
                    </div>
                        <div className="botoes">
                            <Button className='p-button-danger' label='RETROCEDER' icon='pi pi-arrow-left' onClick={() => {
                                    setFluxoGerenciamento('PreConfigQ')
                            }} />
                            <Button className='p-button-success' label='AVANÇAR' icon='pi pi-arrow-right' iconPos="right" style={{background: "#4caf50", width: "1.8in"}} onClick={() => {
                                if(questionario.titulo){
                                    setFluxoGerenciamento('ConfigQ')
                                } else {
                                    showErrorToast('Por favor, preencha todos os campos obrigatórios.');
                                }
                            }} />
                        </div>
                </p>
                <Toast ref={toast} />
            </Card>
        </div>
    )
};

export default InicioConfiguracao;
